var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99176 13.0017C8.81848 13.0002 8.65255 12.9315 8.529 12.81L1.98354 6.26451C1.86431 6.14106 1.79834 5.97572 1.79983 5.8041C1.80132 5.63248 1.87016 5.46832 1.99152 5.34696C2.11287 5.2256 2.27704 5.15676 2.44866 5.15527C2.62028 5.15378 2.78562 5.21975 2.90907 5.33899L8.99176 11.4217L15.0745 5.33899C15.1348 5.27647 15.2071 5.2266 15.2869 5.1923C15.3668 5.158 15.4527 5.13994 15.5396 5.13918C15.6265 5.13843 15.7127 5.15499 15.7931 5.1879C15.8736 5.22081 15.9466 5.26941 16.0081 5.33087C16.0695 5.39233 16.1182 5.46541 16.1511 5.54585C16.184 5.62629 16.2005 5.71248 16.1998 5.79939C16.199 5.8863 16.181 5.97219 16.1467 6.05205C16.1124 6.13191 16.0625 6.20413 16 6.26451L9.45452 12.81C9.33097 12.9315 9.16505 13.0002 8.99176 13.0017Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/down-arrow-icon.98461a98e22df2620693c634b7572ecc.svg";
export { ForwardRef as ReactComponent };